module.exports = __webpack_public_path__ + "img/3-1-5.07c2b801.png";